import { TopicType } from './topics';

type UnsubscribeTokenType = string;

type MessageBusMessageType = (topic: TopicType, data: any) => any;

export interface MessageBusType {
  publish: MessageBusMessageType;
  subscribe: (topic: TopicType, handler: MessageBusMessageType) => UnsubscribeTokenType;
  unsubscribe: (unsubscribeToken: UnsubscribeTokenType) => void;
}

// messageBus getter
export default (): MessageBusType =>
  window.WH &&
  window.WH.messageBus &&
  window.WH.messageBus.publish &&
  window.WH.messageBus.subscribe &&
  window.WH.messageBus.unsubscribe &&
  window.WH.messageBus; // returns the messageBus
